import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";

export const ActiveRecordingConflictModal = observer(() => {
  const { store } = useAppStore();
  const modalStore = store.audio.ui.modals.activeRecordingConflict;

  return (
    <MDSModalDialog
      isOpen={modalStore.isOpen}
      handleClose={() => modalStore.handleClose()}
      isDismissable={!modalStore.isConfirmingUi}
    >
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {modalStore.title}
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>{modalStore.message}</MDSText>
      </MDSDialogTextContent>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton isDisabled={modalStore.isConfirmingUi} onClick={() => modalStore.handleClose()}>
          Cancel
        </MDSButton>
        <MDSButton
          variant={MDSButtonVariant.Contrast}
          onClick={() => {
            void modalStore.handleConfirm();
          }}
          isDisabled={modalStore.isConfirming}
          isLoading={modalStore.isConfirmingUi}
        >
          {modalStore.confirmLabel}
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
